import type { GetMeUserResponse } from "@nlc/shared-types";
import type { UserRoleEnum } from "@nlc/shared-types";

import { CUSTOMER_ROLES } from "@nlc/shared-types";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { ListProjectsPage } from "../../../../../features/projects/list/ListProjectsPage";

export const Route = createFileRoute("/_auth/_app-shell/projects/")({
  beforeLoad: async ({ context }) => {
    const userData = context.queryClient.getQueryData<GetMeUserResponse>([
      "user",
    ]);

    // Block customers from accessing projects list
    const isCustomer = CUSTOMER_ROLES.includes(
      userData?.user?.roleId as UserRoleEnum,
    );

    if (isCustomer) {
      throw redirect({ to: "/requests" as string });
    }
  },
  component: ListProjectsPage,
  head: () => ({
    meta: [
      {
        title: "Accounts - NoLimit Creatives",
      },
    ],
  }),
});
